// SESSION MONEY ARRIVES IN CENTS. PORT OF THE ANGULAR `_parts` COMPONENTS THAT
// RENDER IT - `total-daily-actual` (CARDED), `gains` (UNCARDED), `total-daily-theo`
// AND `egm-theo-win` - INCLUDING THEIR EDGE CASES, SO THE PILOT SHOWS WHAT IN PLAY
// SHOWS TODAY.

const whole = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

export interface ActualDisplay {
  text: string;
  tone: "up" | "down";
  // THE ARROW IS DROPPED WHEN THE ROUNDED AMOUNT IS ZERO
  arrow: boolean;
}

// `total-daily-actual`: UP (GREEN) ONLY WHEN POSITIVE; A LOSS IS "-$N" IN RED; A
// ZERO-OR-NEGATIVE AMOUNT THAT ROUNDS TO ZERO SHOWS NOTHING AT ALL
export function carded(cents: number | undefined): ActualDisplay | null {
  const v = cents ?? 0;
  const up = v > 0;
  const dollars = Math.abs(Number((v / 100).toFixed(0)));
  if (up) return { text: "$" + whole.format(dollars), tone: "up", arrow: dollars !== 0 };
  if (dollars === 0) return null;
  return { text: "-$" + whole.format(dollars), tone: "down", arrow: true };
}

// `gains`: THE SAME TONES, BUT A LOSS KEEPS THE SIGN AFTER THE DOLLAR ("$-3") -
// ANGULAR PRINTS `$` THEN THE SIGNED NUMBER
export function uncarded(cents: number | undefined): ActualDisplay | null {
  const v = cents ?? 0;
  const up = v > 0;
  const dollars = Number((v / 100).toFixed(0));
  if (up) return { text: "$" + whole.format(dollars), tone: "up", arrow: dollars !== 0 };
  if (dollars === 0) return null;
  return { text: "$" + whole.format(dollars), tone: "down", arrow: true };
}

// `total-daily-theo` (CARDED): CENTS TO WHOLE DOLLARS WITH THOUSANDS SEPARATORS
export function theo(cents: number | undefined): string {
  return "$" + theoNumber(cents);
}

// THE NUMBER ALONE, FOR TEMPLATES THAT PRINT THE `$` IN THEIR OWN SPAN
export const theoNumber = (cents: number | undefined) => whole.format(Number(((cents ?? 0) / 100).toFixed(0)));

// `egm-theo-win` (UNCARDED): `(theo / 100).toFixed(0)` - NO THOUSANDS SEPARATOR
export const egmTheoNumber = (cents: number | undefined) => ((cents ?? 0) / 100).toFixed(0);
